/**
 * Author: Claude Code
 * Version: v3.2.18
 * Modified: 2025-10-26 // 显示3行，移除滚动条（仅展示最近3条）
 *
 * ActivityLogBar - 底部活动滚动栏（显示Agent思考和行动）
 */

import React, { useEffect, useRef } from 'react';

export interface ActivityLog {
  id: number;
  timestamp: string;
  agentName: string;
  character: string;
  type: 'thinking' | 'move' | 'combat' | 'item';
  content: string;
}

export interface ActivityLogBarProps {
  logs: ActivityLog[];
}

export const ActivityLogBar: React.FC<ActivityLogBarProps> = ({ logs }) => {
  const scrollRef = useRef<HTMLDivElement>(null);

  // Auto-scroll to latest log entry (scroll to bottom)
  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [logs]);

  const getLogTypeIcon = (type: ActivityLog['type']) => {
    switch (type) {
      case 'thinking': return '💭';
      case 'move': return '🚶';
      case 'combat': return '⚔️';
      case 'item': return '📦';
      default: return '📝';
    }
  };

  // 仅展示最近3条
  const VISIBLE_COUNT = 3;
  const visibleLogs = logs.slice(-VISIBLE_COUNT);

  return (
    <div className="activity-log-bar">
      <div className="activity-scroll-container" ref={scrollRef}>
        {visibleLogs.map((log) => (
          <div key={log.id} className="activity-log-item">
            <span className="log-timestamp">[{log.timestamp}]</span>
            <span className="log-agent">
              {log.character} {log.agentName}:
            </span>
            <span className="log-type-icon">{getLogTypeIcon(log.type)}</span>
            <span className="log-content">{log.content}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
